import { useTranslation } from "react-i18next";
import KiloNewtonMillimetreSquired from "../../../../../components/Math/Units/Metric/KiloNewtonMillimetreSquired";
import { NumberFormatText } from "../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../components/RowValue/RowBody";

function Biegesteifigkeit({ biegesteifigkeit }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterTragglied.flexuralStiffness")}</p>}
      indicesValue={<span>EI</span>}
      inputValue={
        <span className="input">
          <NumberFormatText value={biegesteifigkeit} decimalScale={0} />
        </span>
      }
      unitValue={<KiloNewtonMillimetreSquired />}
    />
  );
}

export default Biegesteifigkeit;
